export default __webpack_public_path__ + "static/media/project1.4d5ad858.png";